/**
 * Prefetches route chunks on link hover for faster navigation (improves LCP on route change).
 * Maps paths to their dynamic imports - must stay in sync with router/routes.
 */
import { paths } from "~/router/paths";

const prefetched = new Set<string>();

const routePrefetchMap: Record<string, () => Promise<unknown>> = {
  [paths.app.home]: () => import("~/pages/dashboard"),
  [paths.app.productDatabase]: () => import("~/pages/product-database"),
  [paths.app.myTrackingStores]: () => import("~/pages/my-trackings/TrackStores"),
  [paths.app.myTrackingStoreDetail]: () => import("~/pages/top-stores/StoreInsights"),
  [paths.app.myTrackingProducts]: () => import("~/pages/my-trackings/Products"),
  [paths.app.topStores]: () => import("~/pages/top-stores"),
  [paths.app.topProducts]: () => import("~/pages/top-products"),
  [paths.adSpyTool.index]: () => import("~/pages/ad-spy-tool-v2"),
  [paths.app.competitorResearch]: () => import("~/pages/competitor"),
  [paths.auth.login]: () => import("~/pages/login"),
  [paths.auth.register]: () => import("~/pages/register"),
  [paths.checkout.index]: () => import("~/pages/checkout"),
};

const pathMatches = (path: string, pattern: string): boolean => {
  if (path === pattern) return true;
  if (!pattern.includes(":")) return path.startsWith(pattern + "/");
  const regex = new RegExp("^" + pattern.replace(/:[^/]+/g, "[^/]+") + "(?:/|$|\\?)");
  return regex.test(path);
};

export const prefetchRoute = (pathname: string): void => {
  const path = pathname.replace(/\?.*$/, "").replace(/\/$/, "") || "/";
  const normalized = Object.keys(routePrefetchMap)
    .sort((a, b) => b.length - a.length)
    .find((key) => pathMatches(path, key));
  if (normalized && !prefetched.has(normalized)) {
    prefetched.add(normalized);
    routePrefetchMap[normalized]?.().catch(() => {});
  }
};
